import { getWeek } from "date-fns"
import { WeekStartDay } from "../../screens/settings/types"
import { weekStartDayToNumber } from "../DateRangePicker/utils"

export const monthNamesArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
]

export const weekdayNamesMap = {
    Monday: "Mo",
    Tuesday: "Tu",
    Wednesday: "We",
    Thursday: "Th",
    Friday: "Fr",
    Saturday: "Sa",
    Sunday: "Su",
}

export const getWeekNumber = (year: number, month: number, day: number, weekStartDay: WeekStartDay): number => {
    // Get the week number for a date
    return getWeek(new Date(year, month, day), {
        weekStartsOn: weekStartDayToNumber(weekStartDay),
    })
}
